import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/promote")({
  beforeLoad: ({ location, params }) => {
    // Redirect bare /promote to /promote/sponsors
    if (location.pathname === `/${params.orgSlug}/admin/promote` ||
        location.pathname === `/${params.orgSlug}/admin/promote/`) {
      throw redirect({
        to: "/$orgSlug/admin/promote/sponsors",
        params: { orgSlug: params.orgSlug },
      });
    }
  },
  component: () => <Outlet />,
});
